import React, { createContext, useEffect, useState } from "react";

export const MedicationsDispensedContext = createContext();

export function MedicationsDispensedProvider(props) {
  const [readyForServerRequest, setReadyForServerRequest] = useState(false);

  const handleReadyForServerRequest = (boolVal) => {
    return setReadyForServerRequest(boolVal);
  };

  const [trayProductsAndCountsData, setTrayProductsAndCountsData] = useState(
    [],
  );

  const [
    trayProductsAndCountsDataCurrentWeek,
    setTrayProductsAndCountsDataCurrentWeek,
  ] = useState([]);

  const [
    trayProductsAndCountsDataPreviousWeek,
    setTrayProductsAndCountsDataPreviousWeek,
  ] = useState([]);

  const handleTrayProductsAndCountsData = (arr) => {
    return setTrayProductsAndCountsData(arr);
  };

  const handleTrayProductsAndCountsDataCurrentWeek = (arr) => {
    return setTrayProductsAndCountsDataCurrentWeek(arr);
  };

  const handleTrayProductsAndCountsDataPreviousWeek = (arr) => {
    return setTrayProductsAndCountsDataPreviousWeek(arr);
  };

  const [batchesCurrentWeek, setBatchesCurrentWeek] = useState([]);
  const handleBatchesCurrentWeek = (arr) => {
    return setBatchesCurrentWeek(arr);
  };

  const [batchesLastWeek, setBatchesLastWeek] = useState([]);
  const handleBatchesLastWeek = (arr) => {
    return setBatchesLastWeek(arr);
  };

  const [batchesSelectedDateRange, setBatchesSelectedDateRange] = useState([]);
  const handleBatchesSelectedDateRange = (arr) => {
    return setBatchesSelectedDateRange(arr);
  };

  const [dispensingOrderIds, setDispensingOrderIds] = useState([]);
  const handleDispensingOrderIds = (arr) => {
    return setDispensingOrderIds(arr);
  };

  const [trayBargraphData, setTrayBargraphData] = useState([]);
  const handleTrayBargraphData = (arr) => {
    return setTrayBargraphData(arr);
  };

  return (
    <MedicationsDispensedContext.Provider
      value={{
        readyForServerRequest,
        handleReadyForServerRequest,
        trayProductsAndCountsData,
        handleTrayProductsAndCountsData,
        trayProductsAndCountsDataCurrentWeek,
        handleTrayProductsAndCountsDataCurrentWeek,
        trayProductsAndCountsDataPreviousWeek,
        handleTrayProductsAndCountsDataPreviousWeek,
        batchesCurrentWeek,
        handleBatchesCurrentWeek,
        batchesLastWeek,
        handleBatchesLastWeek,
        batchesSelectedDateRange,
        handleBatchesSelectedDateRange,
        dispensingOrderIds,
        handleDispensingOrderIds,
        trayBargraphData,
        handleTrayBargraphData,
      }}
    >
      {props.children}
    </MedicationsDispensedContext.Provider>
  );
}
